// extracted by mini-css-extract-plugin
export default {"tableWrapper":"Accounts_tableWrapper__UtpLN","formWrapper":"Accounts_formWrapper__LnKaj"};